<template>
  <div class="homepage-hero-layout">

    <div class="hero-container" :style="heroBG">

      <HomepageLayout>

        <slot></slot>

      </HomepageLayout>

    </div>
    <div class="below-hero">
      <slot name="below-hero-content"></slot>
    </div>
    <BottomNavigation v-if="footer !== 'no'"></BottomNavigation>
  </div>
</template>

<script>
export default {
  props: ['heroImage', 'footer', 'bgPos' ,'minHeight'],
  computed: {
    heroBG() {
      return `
      background-image: linear-gradient(rgba(44,44,44, 0.3), rgba(102,102,102, 1.0)), url(${this.heroImage});
    
      min-height:${this.minHeight || 'calc(100vh - 100px'};
      background-position: ${this.bgPos || 'middle middle'};
      `;
    }
  }
}
</script>



<style lang="scss" scoped>

.hero-container {
    display: block;
    margin: 0 auto;
    background-repeat: no-repeat;
    background-size: cover;
    /* NOTE: The background image, height, min-height, and position are overrided above in a style= attribute*/
    z-index: 10;
    }



</style>




// WEBPACK FOOTER //
// src/components/layout/HomepageHeroLayout.vue